document.addEventListener('DOMContentLoaded', () => {
  const headerGroup = document.getElementById('header-group');
  const announcement = headerGroup?.querySelector('.hiblu-announcement');
  if (announcement) {
    const updateAnnouncementHeight = () => {
      headerGroup.style.setProperty('--hiblu-announcement-height', `${announcement.getBoundingClientRect().height}px`);
    };
    updateAnnouncementHeight();
    if ('ResizeObserver' in window) new ResizeObserver(updateAnnouncementHeight).observe(announcement);
    else window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
  }
  const hoverNavigation = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)');
  const initDesktopMenus = (root) => {
    const nav = root.querySelector('.hiblu-nav');
    if (!nav || nav.dataset.hibluHoverReady) return;
    nav.dataset.hibluHoverReady = 'true';
    const menus = [...nav.querySelectorAll('details.hiblu-brands, details.hiblu-mega')];
    const closeMenus = (except) => menus.forEach((menu) => {
      if (menu !== except) menu.open = false;
    });
    menus.forEach((menu) => {
      let closeTimer;
      menu.addEventListener('pointerenter', () => {
        if (!hoverNavigation.matches) return;
        window.clearTimeout(closeTimer);
        closeMenus(menu);
        menu.open = true;
      });
      menu.addEventListener('pointerleave', () => {
        if (!hoverNavigation.matches) return;
        closeTimer = window.setTimeout(() => { menu.open = false; }, 140);
      });
      menu.addEventListener('focusin', () => window.clearTimeout(closeTimer));
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) menu.open = false;
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) closeMenus(menu);
      });
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.hiblu-nav details')) closeMenus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = menus.find((menu) => menu.open);
      if (!openMenu) return;
      openMenu.open = false;
      openMenu.querySelector('summary')?.focus();
    });
    hoverNavigation.addEventListener('change', () => closeMenus());
  };
  initDesktopMenus(document);
  document.addEventListener('shopify:section:load', (event) => initDesktopMenus(event.target));
  const drawer = document.getElementById('hiblu-mobile-drawer');
  const menuButtons = [...document.querySelectorAll('[data-hiblu-open-menu]')];
  menuButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (drawer && !drawer.open) drawer.showModal();
      menuButtons.forEach((control) => control.setAttribute('aria-expanded', 'true'));
    });
  });
  document.querySelectorAll('[data-hiblu-close-menu]').forEach((button) => {
    button.addEventListener('click', () => drawer?.close());
  });
  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) drawer.close();
  });
  drawer?.addEventListener('close', () => {
    menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  });
  const mobileSearch = document.getElementById('hiblu-mobile-search');
  document.querySelectorAll('[data-hiblu-open-search]').forEach((button) => {
    button.addEventListener('click', () => {
      if (mobileSearch && !mobileSearch.open) mobileSearch.showModal();
      mobileSearch?.querySelector('input[type="search"]')?.focus();
    });
  });
  document.querySelectorAll('[data-hiblu-close-search]').forEach((button) => {
    button.addEventListener('click', () => mobileSearch?.close());
  });
  mobileSearch?.addEventListener('click', (event) => {
    if (event.target === mobileSearch) mobileSearch.close();
  });
  document.querySelectorAll('[data-hiblu-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  const refreshCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const { item_count: count } = await response.json();
      const cartLink = document.querySelector('[data-hiblu-cart-link]');
      if (cartLink) {
        cartLink.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
        let badge = cartLink.querySelector('.hiblu-cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'hiblu-cart-count';
            cartLink.append(badge);
          }
          badge.textContent = count;
        } else badge?.remove();
      }
      const mobileCount = document.querySelector('[data-hiblu-cart-mobile]');
      if (mobileCount) mobileCount.textContent = count > 0 ? `Cart (${count})` : 'Cart';
    } catch { /* The cart link still navigates if the count request fails. */ }
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest('button[name="add"], .cart-items__remove, button[aria-label^="Remove "], cart-quantity-selector-component button[name="plus"], cart-quantity-selector-component button[name="minus"]')) return;
    [500, 1500, 3500].forEach((delay) => window.setTimeout(refreshCartCount, delay));
  });
  document.addEventListener('change', (event) => {
    if (!event.target.closest('cart-quantity-selector-component input')) return;
    [500, 1500].forEach((delay) => window.setTimeout(refreshCartCount, delay));
  });
  document.addEventListener('cart:updated', refreshCartCount);
  document.addEventListener('cart:update', refreshCartCount);

  const initShowcaseCarousels = (root) => {
    root.querySelectorAll('.hiblu-home-showcase').forEach((section) => {
      if (section.dataset.hibluCarouselReady) return;
      const track = section.querySelector('[data-hiblu-carousel]');
      const previous = section.querySelector('[data-hiblu-carousel-prev]');
      const next = section.querySelector('[data-hiblu-carousel-next]');
      const pagination = section.querySelector('[data-hiblu-carousel-pagination]');
      if (!track || !previous || !next) return;
      section.dataset.hibluCarouselReady = 'true';
      let pageCount = 0;
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const updateControls = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (!pagination || pageCount < 2) return;
        const activePage = Math.round((track.scrollLeft / maxScroll()) * (pageCount - 1));
        pagination.querySelectorAll('button').forEach((dot, index) => {
          if (index === activePage) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const updatePagination = () => {
        if (!pagination) return;
        const count = maxScroll() < 4 ? 0 : Math.min(10, Math.max(2, Math.ceil(track.scrollWidth / track.clientWidth)));
        if (count !== pageCount) {
          pageCount = count;
          const dots = Array.from({ length: count }, (_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `Go to carousel page ${index + 1} of ${count}`);
            dot.addEventListener('click', () => {
              track.scrollTo({ left: maxScroll() * index / (pageCount - 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            });
            return dot;
          });
          pagination.replaceChildren(...dots);
        }
        pagination.hidden = count < 2;
        updateControls();
      };
      const move = (direction) => {
        const card = track.querySelector('.hiblu-home-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updatePagination, { passive: true });
      updatePagination();
    });
  };
  initShowcaseCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initShowcaseCarousels(event.target));

  const slider = document.querySelector('[data-hiblu-slider]');
  if (!slider) return;
  const slides = [...slider.querySelectorAll('[data-hiblu-slide]')];
  const dots = [...slider.querySelectorAll('[data-hiblu-dot]')];
  const interval = 5000;
  const transition = 850;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let active = 0;
  let autoTimer;
  let transitionTimer;
  let remaining = interval;
  let startedAt = 0;
  let focusPaused = false;
  let hoverPaused = false;
  const shouldPause = () => focusPaused || hoverPaused || document.hidden || reducedMotion.matches;
  const syncAutoplay = () => {
    if (shouldPause() || slides.length < 2) {
      if (autoTimer) {
        remaining = Math.max(0, remaining - (performance.now() - startedAt));
        window.clearTimeout(autoTimer);
        autoTimer = undefined;
      }
      slider.classList.add('is-paused');
      return;
    }
    slider.classList.remove('is-paused');
    if (autoTimer) return;
    startedAt = performance.now();
    autoTimer = window.setTimeout(() => {
      autoTimer = undefined;
      show(active + 1);
    }, remaining);
  };
  const finishTransition = () => {
    window.clearTimeout(transitionTimer);
    slides.forEach((slide, i) => {
      const isActive = i === active;
      slide.classList.remove('is-entering', 'is-leaving');
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
      slide.inert = !isActive;
      slide.setAttribute('aria-hidden', String(!isActive));
    });
  };
  const show = (index) => {
    const next = (index + slides.length) % slides.length;
    if (next === active) return;
    finishTransition();
    const outgoing = slides[active];
    const incoming = slides[next];
    active = next;
    incoming.hidden = false;
    incoming.inert = false;
    incoming.setAttribute('aria-hidden', 'false');
    outgoing.inert = true;
    outgoing.setAttribute('aria-hidden', 'true');
    dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === active)));
    window.clearTimeout(autoTimer);
    autoTimer = undefined;
    remaining = interval;
    if (reducedMotion.matches) {
      finishTransition();
      syncAutoplay();
      return;
    }
    outgoing.classList.add('is-leaving');
    incoming.classList.add('is-entering');
    transitionTimer = window.setTimeout(finishTransition, transition);
    syncAutoplay();
  };
  finishTransition();
  slider.classList.add('is-ready');
  syncAutoplay();
  slider.querySelector('[data-hiblu-previous]')?.addEventListener('click', () => show(active - 1));
  slider.querySelector('[data-hiblu-next]')?.addEventListener('click', () => show(active + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
  slider.addEventListener('mouseenter', () => { hoverPaused = true; syncAutoplay(); });
  slider.addEventListener('mouseleave', () => { hoverPaused = false; syncAutoplay(); });
  slider.addEventListener('focusin', () => { focusPaused = true; syncAutoplay(); });
  slider.addEventListener('focusout', (event) => {
    if (!slider.contains(event.relatedTarget)) { focusPaused = false; syncAutoplay(); }
  });
  document.addEventListener('visibilitychange', syncAutoplay);
  reducedMotion.addEventListener('change', syncAutoplay);
});
